module.exports = "../images/cabin2.jpg?v=6020763";